// Styles
import "./Metro.scss";

// Redux
import { selectSteps } from "app/store/metro/metroSlice";
import { useAppSelector } from "app/store/hooks";

// Utils
import { stepLabels } from "utils/core/constants";
import { useLocation, useNavigate } from "react-router-dom";
import { RecapPageMandatoryConsentItemExtended } from "../privacy/Privacy";
import {
	selectCurrentIndex,
	selectMandatoryConsents
} from "app/store/privacyConsents/privacyConsentsSlice";

// Types
export type Step = {
	index: number;
	pageName: string;
};
const getClasses = (
	currentStepIndex: number,
	stepIndex: number,
	classes: string[],
	isMandatoryPrivacySelected: boolean
): string => {
	if (currentStepIndex === stepIndex) {
		return classes[0];
	}
	if (currentStepIndex > stepIndex) {
		return classes[1];
	}
	if (stepIndex === 2 && isMandatoryPrivacySelected) {
		return classes[1];
	}
	return "";
};

// Element
const Metro = ({ currentStep }: { currentStep: Step }): JSX.Element => {
	const steps = useAppSelector(selectSteps);
	const navigate = useNavigate();
	const { search } = useLocation();
	const mandatoryConsents =
		useAppSelector<RecapPageMandatoryConsentItemExtended[]>(selectMandatoryConsents);
	const privacyCountAccepted = useAppSelector<number>(selectCurrentIndex);

	const handleStepperClick = (
		currentStep: Step,
		step: Step,
		isKeyboardEvent = false,
		event?: React.KeyboardEvent
	): void => {
		const isNavigable =
			currentStep.index > step.index || (step.index === 2 && mandatoryConsents[0]?.given);
		const isKeyValid = event?.key === "Enter" || event?.key === " ";

		if (isNavigable && (!isKeyboardEvent || isKeyValid)) {
			navigate(`${step.pageName}${search}`);
		}
	};

	return (
		<div className="stepper">
			{steps.map((step: Step, key: number) => {
				return (
					<div
						className={`step-wrapper ${getClasses(
							currentStep?.index,
							step.index,
							["selected current", "selected"],
							mandatoryConsents[0]?.given
						)}`}
						key={key}
					>
						{key > 0 && (
							<div className="step-line">
								<div className={"step-line-content"}></div>
							</div>
						)}
						<div
							tabIndex={
								currentStep?.index > step.index ||
								currentStep?.index === step.index ||
								getClasses(
									currentStep?.index,
									step.index,
									["selected current", "selected"],
									mandatoryConsents[0]?.given
								).includes("selected")
									? 0
									: -1
							}
							className="step"
							role="button"
							onClick={() => {
								handleStepperClick(currentStep, step);
							}}
							onKeyDown={(event) => {
								handleStepperClick(currentStep, step, true, event);
							}}
						>
							<div
								className={`step-icon sky-body-small ${getClasses(
									currentStep?.index,
									step.index,
									["selected current", "selected"],
									mandatoryConsents[0]?.given
								)}`}
							>
								<p
									className={
										currentStep?.index > step.index ||
										(step.index === 2 &&
											privacyCountAccepted === 10 &&
											mandatoryConsents[0]?.given &&
											!getClasses(
												currentStep?.index,
												step.index,
												["selected current", "selected"],

												mandatoryConsents[0]?.given
											).includes("current"))
											? "checked"
											: ""
									}
									aria-label={
										currentStep?.index > step.index ||
										(step.index === 2 &&
											privacyCountAccepted === 10 &&
											mandatoryConsents[0]?.given &&
											!getClasses(
												currentStep?.index,
												step.index,
												["selected current", "selected"],

												mandatoryConsents[0]?.given
											).includes("current"))
											? "Completato"
											: "Non Completato"
									}
								>
									{currentStep?.index > step.index ||
									(step.index === 2 &&
										privacyCountAccepted === 10 &&
										mandatoryConsents[0]?.given &&
										!getClasses(
											currentStep?.index,
											step.index,
											["selected current", "selected"],

											mandatoryConsents[0]?.given
										).includes("current"))
										? "L"
										: step.index}
								</p>
							</div>
							<p
								className={`step-label medium ${getClasses(
									currentStep?.index,
									step.index,
									["selected current", "selected"],
									mandatoryConsents[0]?.given
								)}`}
							>
								{stepLabels[key]}
							</p>
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default Metro;
